module.exports = __webpack_public_path__ + "img/12.528db3eb.jpg";